import stores from "@/storage/stores";

import JSEncrypt from 'jsencrypt';

export async function encryptPassword(password: string) {
    try {
        const publicKey = stores.getStoresData().setting?.find(
            (s: { key: string, value: string }) => s.key === 'publicKey'
        )?.value;

        if (!publicKey) {
            throw new Error("Clé publique non trouvée");
        }

        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);

        const encrypted = encrypt.encrypt(password);

        if (!encrypted) {
            throw new Error("Échec du chiffrement");
        }

        return encrypted;

    } catch (error) {
        throw error;
    }
}